import {useLocalStorage} from '@aboutyou/storage';
import {USER_PERSIST_OPTIONAL_KEY} from './constants';
import {OptionalUserState} from './types';

export const useOptionalUser = () => {
  const [optionalUser, setOptionalUser] = useLocalStorage<OptionalUserState>({
    key: USER_PERSIST_OPTIONAL_KEY,
    defaultValue: {userData: null},
  });

  const saveData = (data: OptionalUserState | undefined) => {
    if (data && !data.userData) {
      setOptionalUser(undefined);
      return;
    }

    setOptionalUser(data);
  };

  return {data: optionalUser, updateCache: saveData};
};
